<template>
  <div class="qunti-huaxiang-detail child-detail">
    <ChildModal :title="$store.state.childModalTitle">
      <div class="title">

        <ul class="tab">
          <li>
            <div @click="scenicListShow = !scenicListShow" class="expand">
              <div class="icon">
                <img src="../../assets/header_menu/spot.png" />
              </div>
              <div class="drop-name">{{scenicSelected}}</div>
              <div class="arrow"></div>

              <ul class="drop-list" v-show="scenicListShow">
                <li :key="index"
                    @click="scenicSelected = item"
                    v-for="(item, index) in scenicList">
                  {{ item }}
                </li>
              </ul>
            </div>
          </li>

          <li style="width: 20px"></li>

          <li>
            <div @click="dateListShow = !dateListShow" class="expand">
              <div class="icon">
                <img src="../../assets/header_menu/time.png" />
              </div>
              <div class="drop-name">{{dateSelected}}</div>
              <div class="arrow"></div>

              <ul class="drop-list" v-show="dateListShow">
                <li :key="index"
                    @click="dateSelected = item"
                    v-for="(item, index) in dateList">
                  {{ item }}
                </li>
              </ul>
            </div>
          </li>

          <li>
            <div @click="sortListShow = !sortListShow" class="expand">
              <div class="icon">
                <img src="../../assets/sort.png" />
              </div>
              <div class="drop-name">{{sortSelected}}</div>
              <div class="arrow"></div>

              <ul class="drop-list" v-show="sortListShow">
                <li :key="index"
                    @click="sortSelected = item"
                    v-for="(item, index) in sortList">
                  {{ item }}
                </li>
              </ul>
            </div>
          </li>

          <li>
            <div @click="typeListShow = !typeListShow" class="expand">
              <div class="icon">
                <img src="../../assets/index/content.png" />
              </div>
              <div class="drop-name">{{typeSelected}}</div>
              <div class="arrow"></div>

              <ul class="drop-list" v-show="typeListShow">
                <li :key="index"
                    @click="typeSelected = item"
                    v-for="(item, index) in typeList">
                  {{ item }}
                </li>
              </ul>
            </div>
          </li>
        </ul>

        <div class="search">
          <input type="text" placeholder="输入关键词搜索" />
          <div class="search-btn"></div>
        </div>
      </div>

      <div class="subTitle" ></div>
      <div>
        <div class="subTitle">负面评价关键词</div>
        <JingquPingceCiyunCP id="fumianpingjiaguanjianciDetailChart"
                             :chartData="fumianpingjiaguanjianCiyunData"
                             v-if="fumianpingjiaguanjianCiyunData"/>
      </div>

      <div>
        <div class="subTitle">正面评价关键词</div>
        <JingquPingceCiyunCP id="zhengmianpingjiaguanjianciDetailChart"
                             :chartData="zhengmianpingjiaguanjianCiyunData"
                             v-if="zhengmianpingjiaguanjianCiyunData"/>
      </div>

      <div>
        <div class="subTitle">负面评价内容分类</div>
        <Radar id="fumianpingjianeirongDetailChart"
               :width = "containerSizeW"
               :height= "containerSizeH"
               :center="{x:'50%',y:'50%'}"
               :chartData="fumianpingjianeirongData"
               v-if="fumianpingjianeirongData"/>
      </div>

      <div>
        <div class="subTitle">正面评价内容分类</div>
        <Radar id="zhengmianpingjianeirongDetailChart"
               :width = "containerSizeW"
               :height= "containerSizeH"
               :center="{x:'50%',y:'50%'}"
               :chartData="zhengmianpingjianeirongData"
               v-if="zhengmianpingjianeirongData"/>
      </div>



      <div class="zhanwei"></div>
    </ChildModal>
  </div>
</template>

<script>
import ChildModal from "@/components/Common/ChildModal.vue";

import JingquPingceCiyunCP from "@/components/Echarts/JingquKoubei/JingquPingceCiyun.vue";
import Radar from "@/components/Echarts/Radar.vue";

export default {
  name: "FumianpingjiaguanjianciDetail",
  components: {
    ChildModal,
    JingquPingceCiyunCP,
    Radar
  },
  props: {},
  data() {
    return {
      fumianpingjiaguanjianCiyunData: null,
      zhengmianpingjiaguanjianCiyunData: null,
      fumianpingjianeirongData: null,
      zhengmianpingjianeirongData: null,

      sizeW: 500,
      sizeH: 500,

      scenicSelected: "黄山",
      scenicListShow: false,
      scenicList: ["黄山","泰山","衡山"],

      dateSelected: "一周内",
      dateListShow: false,
      dateList: ["一周内","一月内","三月内","一年内"],

      sortSelected: "时间",
      sortListShow: false,
      sortList: ["时间","热度"],

      typeSelected: "综合",
      typeListShow: false,
      typeList: ["综合","新闻资讯","论坛","贴吧","博客","微博","微信","OTA","视频","问答"],
    };
  },
  computed: {
    containerSizeW: function() {
      return this.sizeW + "px"

    },containerSizeH: function() {
      return this.sizeH + "px"
    }
  },
  mounted() {
    // 负面评价关键词云
    fetch("/data/Lvyouyulun/Fumianpingjiaguanjianciyun.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          this.fumianpingjiaguanjianCiyunData = json.data;
          this.zhengmianpingjiaguanjianCiyunData = json.data;
        });

    // 舆情类型分析
    fetch("/data/Lvyouyulun/Yuqingleixinfenxi.json")
        .then(response => {
          return response.json();
        })
        .then(json => {

          let nameLists = []
          let dataLists = []
          json.data.data.forEach(function (dd) {
            nameLists.push(dd.name)
            dataLists.push(dd.value)
          })

          let tempBarData = {
            nameList : nameLists,
            data : dataLists
          }

          let tempRadarData = {
            nameList : nameLists,
            data : [{
              legend :"评价内容分类",
              valueList :dataLists
            }]
          }
          this.fumianpingjianeirongData = tempRadarData
          this.zhengmianpingjianeirongData = tempRadarData

        });
  },
  methods: {
  }
};
</script>

<style scoped lang="less">

  .subTitle {
    height: 0.5rem;
    font-size: 0.2rem;
    color: #00cdf9;
    font-weight: bold;
    text-align: center;
  }
  .title {
    height: 0.5rem;
    font-size: 0.18rem;
    color: #00cdf9;
    font-weight: bold;
    float: left;width: 100%;
      position: relative;
    .tab {
      /*width: 3.5rem;*/
      /*height: 0.3rem;*/
      /*margin: 0 auto 0.16rem;*/

      > li {
        width: 1.5rem;
        height: 0.34rem;
        line-height: 0.3rem;
        float: left;
        color: @base-text-color;
        cursor: pointer;
        > div {
          float: left;
        }
        .expand {
          /*width: 1.5rem;*/
          height: 0.3rem;
          position: absolute;
          cursor: pointer;
          > div {
            float: left;
            /*width: 0.3rem;*/
            height: 0.3rem;
            line-height: 0.3rem;
                margin-left: 0.1rem;
          }
          .local {
            width: 0.3rem;
            background: url(../../assets/youkexianxiaxingweifenxi/local.png);
            background-size: 100% 100%;
          }
          .arrow {
            width: 30px;
            height: 0.3rem;
            background: url(../../assets/header_menu/arrow.png);
            background-size: 100% 100%;
          }
          .icon {
            width: 20px;
            height: 20px;
            margin-top: -3px;
          }
          .drop-list {
            z-index: 9999;
            position: absolute;
            left: 0;
            top: 0.3rem;
            width: 100%;
            background: #052148;
            border: 1px solid #00cdff;
            padding: 0.05rem 0;
            box-sizing: border-box;
            li:hover {
              background: #0c3964;
            }
          }
        }
      }
    }
  }
  .search {
    width: 2.3rem;
    height: 0.3rem;
    position: absolute;
    top: 0;
    right: 0.3rem;
    input {
      width: 2.02rem;
      height: 0.26rem;
      background: #0e264b;
      border: 0.02rem solid #07779e;
      outline: none;
      float: left;
      padding-left: 0.1rem;
      color: #fff;
          font-size: 0.16rem;
          padding: 0.05rem;
    }
    .search-btn {
      width: 0.26rem;
      height: 0.26rem;
      float: right;
      background: rgba(0, 0, 0, 0.5) url(../../assets/spot_search_btn.jpg);
      background-size: 100% 100%;
      cursor: pointer;
    }
    input::-webkit-input-placeholder {
      color: #ccc;
    }
  }
</style>
